import React from 'react';
import { Button, Card, Link } from '@superops/ui-design-system';
import { AccessControl } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';

const AttachmentHolder = (props: any) => {
  const { type, url, fileName, onClick, onDelete, fontWeight, padded } = props;

  return (
    <div>
      <Card variant="secondaryCard" noShadow AdaptHeight>
        <div className="flex actr mt-0 word-break fx-sb p8">
          <span className={`ml8 fx actr mr8 ${padded ? 'py-10' : ''}`}>
            <Link
              onClick={onClick}
              fontWeight={fontWeight || 'normal'}
              removeUnderline
            >
              {fileName}
            </Link>
          </span>
          {onDelete && (
            <AccessControl
              roleToCheck="fileAttachments.delete"
              render={
                <Button
                  onClick={onDelete}
                  plainSecondary
                  icon={<SVGIcon name="Delete" size="sm" />}
                />
              }
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default AttachmentHolder;
